import React, { FC } from 'react';
import { BreakpointsInPx } from '../../../../../constants/breakpoints.constants';
import { iconSize } from '../../../../../constants/icon.constants';
import useMediaQuery from '../../../../../lib/custom-hooks/useMediaQuery';
import { handleThumbnailImage } from '../../../../../utils/youtubeUtils';
import Icon from '../../../icon';
import { TCarouselNavDeckCardProps } from './types/carouselNavDeck.types';
import Picture from '../../../picture';
import { TImageComponentProps } from '../../../picture/types/picture.types';

const CarouselNavDeckCard: FC<TCarouselNavDeckCardProps> = ({ slide, currentCardIndex, goToCard, index, isEE, editorial }) => {
  const isWide = useMediaQuery(`(min-width: ${BreakpointsInPx.md})`);

  const getPictureProps = (): TImageComponentProps => {
    if (editorial) {
      return {
        editorialImageProps: {
          id: slide.id,
          desktopImage: slide.desktopImage,
          mobileImage: slide.mobileImage,
          alt: slide.desktopAlt,
          isVideoThumbnail: slide.isVideo,
          cssClassPictureEl: 'overlay-carousel-popup__slide-image--fixed-aspect-ratio',
        },
      };
    } else {
      return {
        productImageProps: {
          desktopRendition: slide.desktopRendition,
          mobileRendition: slide.mobileRendition,
          isVideoThumbnail: slide.isVideo,
          pictureClassName: 'overlay-carousel-popup__slide-image--fixed-aspect-ratio',
          onLoad: (e) => {
            handleThumbnailImage(e, slide?.isVideo);
          },
        },
      };
    }
  };

  return (
    <div
      key={`overlay-carousel-popup__slide-image-wrapper-${index}`}
      id={`overlay-carousel-popup__slide-image-wrapper-${index}`}
      className="overlay-carousel-popup__slide-image-wrapper"
      onClick={(): void => goToCard(index)}
    >
      {!isEE && (
        <div
          className={`
          overlay-carousel-popup__slide-image-blur
          ${currentCardIndex === index && ' overlay-carousel-popup__slide-image-blur--deactivate'}
        `}
        />
      )}
      {!isEE && <div className={currentCardIndex === index ? 'overlay-carousel-popup__slide-highlight-bar' : ''} />}
      {slide.isVideo && !isEE && (
        <div
          className={`
            overlay-carousel-popup__slide-video-play-button-slider
            overlay-carousel-popup__slide-video-play-button-slider--in-slider
            ${currentCardIndex !== index && 'overlay-carousel-popup__slide-video-play-button-slider--blur'}
        `}
        >
          <Icon iconName="action-play" extraClassName="overlay-carousel-popup__play-icon" size={isWide ? iconSize.dsk : iconSize.xxs} />
        </div>
      )}
      <Picture {...getPictureProps()} />
    </div>
  );
};

export default React.memo(CarouselNavDeckCard);
